import React from "react";
import "./footer.css";
import {
    FaFacebookF,
    FaTwitter,
    FaLinkedinIn,
    FaInstagram,
    FaWhatsapp,
} from "react-icons/fa";

const ASIFooter = () => {
    return (
        <section className="asi-footer-section-tag">
            <footer className="container asi-footer">
                {/* Social Icons */}
                <div className="asi-footer-top">
                    <div className="asi-social-icons">
                        <FaFacebookF />
                        <FaTwitter />
                        <FaLinkedinIn />
                        <FaInstagram />
                        <FaWhatsapp />
                    </div>
                </div>

                {/* Divider */}
                <hr className="asi-footer-divider" />

                {/* Bottom */}
                <div className="asi-footer-bottom">
                    <div className="asi-footer-left">
                        <p>© 2026 Acoustical Surfaces – All Rights Reserved.</p>
                        <p>Acoustical Supply and Installation Contractor</p>
                        <p>Acoustical Products Manufacturer</p>
                        <p>Email: mail@acousticalsurfaces.in</p>
                    </div>

                    <div className="asi-footer-right">
                        <p className="asi-help-line">
                            <span>Noise Control Help Line: Call Now</span>

                            <a
                                href="https://wa.me/919449777212"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="asi-whatsapp-link"
                                aria-label="Chat with us on WhatsApp"
                            >
                                <FaWhatsapp className="asi-whatsapp-icon" />
                                <span className="wts-num">+91-94497 77212</span>
                            </a>
                        </p>
                        <div className="asi-footer-links">
                            <span>Terms of Service</span>
                            <span>|</span>
                            <span>Privacy Policy</span>
                            <span>|</span>
                            <span>Search</span>
                        </div>
                    </div>
                </div>
            </footer>
        </section>
    );
};

export default ASIFooter;